import React from 'react'
import { RenderControl, IRenderControl } from '@fareye/ui'
import { IMapper, useMapper, TimeZoneProvider } from '@fareye/common'
import { AlertReport } from './containers'
import version from '../../config/npmVersions'

export function AlertReportMapper(props: IMapper) {
  const [apiData, _] = useMapper({ ...props, version })
  return (
    <TimeZoneProvider>
      <RenderControl variant="m" state={apiData as IRenderControl}>
        <AlertReport {...props} config={(apiData as IRenderControl).data} />
      </RenderControl>
    </TimeZoneProvider>
  )
}
